<template>
  <div>
    <div :id="id" ref="barchart" class="barchart-style" />
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(88,198,228, 1)'
    },
    id: {
      type: String,
      default: '',
      require: true
    },
    left: {
      type: String,
      default: '10%'
    },
    top: {
      type: String,
      default: '10%'
    },
    right: {
      type: String,
      default: '0'
    },
    bottom: {
      type: String,
      default: '10%'
    },
    dataName: {
      type: Array,
      default: null
    },
    dataSource: {
      type: Array,
      default: null
    },
    yAxisMinInterval: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      barchart: {},
      shouldCallChartInit: false
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    /** 重新加载echarts图标方法 dataName:X轴名称 dataSource:对应参数  */
    chartInit(dataName, dataSource) {
      this.barchart = this.$echarts.init(document.getElementById(this.id))
      this.barchart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: dataName,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              color: '#333',
            },
            formatter: function (params) {
              var val = '';
              if (params.length > 30) {
                val = params.substr(0, 30) + '...';
                return val;
              } else {
                return params;
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: 'dashed'
            }
          },
          minInterval: this.yAxisMinInterval
        },
        dataZoom: {
          show: true,
          start: 0,
          type: 'inside',
          end: (dataSource.length) * 100,
          zoomLock: true
        },
        series: [
          {
            type: 'bar',
            barWidth: '20%',
            barMaxWidth: '30',
            data: dataSource,
            itemStyle: {
              color: this.color,
              barBorderRadius: [5, 5, 0, 0]
            }
          }
        ],
        grid: {
          left: this.left,
          top: this.top,
          right: this.right,
          bottom: this.bottom
        }
      })
    }
  }
}
</script>
<style>
.barchart-style {
  width: 100%;
  height: 236px;
}
</style>
